import { IconFileText } from "@tabler/icons-react";
import Card from "./Card";
import styles from "../TalentProfile.module.css";

export default function SummaryCard({ summary }) {
  return (
    <Card icon={IconFileText} title="Summary" subtitle="Professional overview">
      <p className={styles.summaryText}>{summary}</p>
    </Card>
  );
}
